import { render, staticRenderFns } from "./labelsBrand.vue?vue&type=template&id=c67db764&"
import script from "./labelsBrand.vue?vue&type=script&lang=js&"
export * from "./labelsBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports